import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import LocationsNavigationIcon from '../../Icons/NavigationItem/Locations';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';

const LazyLocationsPage = React.lazy(() => import('./Pages/LocationsPage'));

const locationsConfiguration: FeatureConfiguration = {
    name: 'Locations',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureLocationsTitle',
            url: '/locations',
            Icon: LocationsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyLocationsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewProperty],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.location) {
            return settings.location.visible;
        }

        return false;
    },
};

export default locationsConfiguration;
